module.exports = __webpack_public_path__ + "static/media/1.a65d8498.jpg";